const scriptDefinitions = [
  {
    name: 'pdfjsLib',
    src: 'https://unpkg.com/pdfjs-dist@2.3.200/build/pdf.min.js',
  },
  {
    name: 'PDFLib',
    src: 'https://unpkg.com/pdf-lib@1.4.0/dist/pdf-lib.min.js',
  },
  {
    name: 'download',
    src: 'https://unpkg.com/downloadjs@1.4.7',
  },
  {
    name: 'JSZip',
    src: 'https://unpkg.com/jszip@3.10.1/dist/jszip.min.js',
  },
  { name: 'makeTextPDF', src: '/makeTextPDF.js' },
];

const scriptDefinitionByName = new Map(scriptDefinitions.map((script) => [script.name, script]));
const assetPromisesByName = new Map();

export function loadAsset(name) {
  if (assetPromisesByName.has(name)) return assetPromisesByName.get(name);
  const scriptDefinition = scriptDefinitionByName.get(name);
  if (!scriptDefinition) throw new Error(`Script ${name} not exists.`);
  return loadScriptAsset(scriptDefinition);
}

function loadScriptAsset({ name, src }) {
  if (assetPromisesByName.has(name)) return assetPromisesByName.get(name);

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(window[name]);
    };
    script.onerror = () => {
      reject(new Error(`The script ${name} didn't load correctly.`));
      alert(`Some scripts did not load correctly. Please reload and try again.`);
    };
    document.body.appendChild(script);
  });

  assetPromisesByName.set(name, promise);
  return promise;
}

export default function preloadAssets() {
  scriptDefinitions.forEach((script) => loadScriptAsset(script));
}

export const Fonts = {
  標楷體: {
    src: '/CK.ttf',
    correction(size, lineHeight) {
      return (size * lineHeight - size) / 2;
    },
  },
};

const loadedFontsByName = new Map(
  Object.entries(Fonts)
    .filter(([, font]) => !font.src)
    .map(([name, font]) => [name, Promise.resolve(font)]),
);

export function loadFont(name) {
  if (loadedFontsByName.has(name)) return loadedFontsByName.get(name);

  const font = Fonts[name];
  if (!font) throw new Error(`Font '${name}' not exists.`);

  if (!font.src) {
    const promise = Promise.resolve(font);
    loadedFontsByName.set(name, promise);
    return promise;
  }

  const promise = fetch(font.src)
    .then((r) => r.arrayBuffer())
    .then((buffer) => {
      const fontFace = new FontFace(name, buffer);
      fontFace.display = 'swap';
      fontFace.load().then(() => document.fonts.add(fontFace));
      return {
        ...font,
        buffer,
      };
    });

  loadedFontsByName.set(name, promise);
  return promise;
}

export function addCustomFont(file) {
  const name = file.name.replace(/\.[^/.]+$/, "");
  if (Fonts[name]) return Promise.resolve(name);

  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const buffer = e.target.result;
      const fontFace = new FontFace(name, buffer);
      fontFace.display = 'swap';
      fontFace.load().then(() => document.fonts.add(fontFace)).catch(console.error);

      Fonts[name] = {
        correction(size, lineHeight) {
          return (size * lineHeight - size) / 2;
        },
        buffer
      };

      resolve(Fonts[name]);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });

  loadedFontsByName.set(name, promise);
  return promise.then(() => name);
}
